import { useContext } from "react";

import {
  Button,
  StepperDispatchContext,
  StepperStateContext,
} from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import styles from "./RequestStepperActions.module.scss";

type Props = {
  stepperState: any;
  stepperApi: any;
};

export default function RequestStepperActions({
  stepperState,
  stepperApi,
}: Props) {
  const stepperStateContext = useContext(StepperStateContext);
  const stepperDispatch = useContext(StepperDispatchContext);
  const { t } = useTranslation();

  const handleNext = () => {
    const action =
      stepperStateContext &&
      stepperStateContext.toNext &&
      stepperStateContext.toNext();

    if (action !== false) {
      stepperDispatch && stepperDispatch({ type: "next", payload: undefined });
      stepperApi.moveToNext();
    }

    window.scrollTo(0, 0);
  };

  const handlePrevious = () => {
    stepperStateContext &&
      stepperStateContext.toPrevious &&
      stepperStateContext.toPrevious();

    stepperDispatch &&
      stepperDispatch({ type: "previous", payload: undefined });
    stepperApi.moveToPrevious();

    window.scrollTo(0, 0);
  };

  return (
    <div className={styles.stepperButtons}>
      {(stepperState.currentStep > 0 && stepperState.currentStep < 5) ||
      (stepperState.currentStep === 0 && stepperState.currentSubstep > 0) ? (
        <Button onClick={handlePrevious} size="lg" color="primary" outline>
          {t("request.prevStepButton")}
        </Button>
      ) : (
        <></>
      )}

      <Button onClick={handleNext} size="lg">
        {stepperState.currentStep !== 5
          ? t("request.nextStepButton")
          : t("request.submitButton")}
      </Button>
    </div>
  );
}
